import Container from "@/common/Layout/Container/Container";
import useTrans from "@/hooks/useTrans";
import { useApiContext } from "@/setup/flexbiz-api-provider";
import {
  Anchor,
  Box,
  Breadcrumbs,
  Grid,
  SimpleGrid,
  Text,
  Title,
} from "@mantine/core";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import ProfileLayout from "./profileLayout";

export default function UserProfile() {
  const trans = useTrans();
  const routes = [
    { title: trans?.profile.manager.home, href: "/" },
    { title: trans?.profile.manager.title, href: "/user-profile" },
  ];
  const route = [
    {
      title: trans?.profile.manager.info,
      href: "/user-profile/my-profile",
      dcr: trans?.profile.manager.info_dcr,
    },
    {
      title: trans?.profile.manager.address,
      href: "/user-profile/address-book",
      dcr: trans?.profile.manager.address_dcr,
    },
    {
      title: trans?.profile.manager.purchase,
      href: "/user-profile/purchased-return",
      dcr: trans?.profile.manager.purchase_dcr,
    },
    {
      title: trans?.profile.manager.liked,
      href: "/user-profile/liked-product",
      dcr: trans?.profile.manager.liked_dcr,
    },
    // {
    //   title: "Thông báo của tôi",
    //   href: "/user-profile/notifycations",
    //   dcr: " Quản lý thông báo",
    // },
  ];
  const context = useApiContext();
  const router = useRouter();
  React.useEffect(() => {
    if (!localStorage.getItem("token")) {
      context.setProgressStatus(false);
      router.push({ pathname: "/dang-nhap" });
    }
  }, [context]);
  return (
    <Container>
      <div style={{ padding: "20px 0px" }}>
        <Breadcrumbs>
          {routes?.map((item, index) => (
            <Link scroll={false} href={item.href} key={index}>
              <a>{item.title}</a>
            </Link>
          ))}
        </Breadcrumbs>
        <Title align="center" order={5} sx={{ padding: "20px 0px" }}>
          {trans?.profile.manager.title}
        </Title>
        <Grid>
          {route?.map((item, index) => (
            <Grid.Col xs={6} md={4} key={index}>
              <Link scroll={false} href={item.href}>
                <Box
                  sx={{
                    width: "100%",
                    minHeight: 150,
                    height: "100%",
                    border: "1px solid rgba(0,0,0,.125)",
                    borderRadius: 5,
                    padding: 20,
                    cursor: "pointer",
                    // background: "rgb(241, 241, 241)",
                    background: "linear-gradient(#fff,#f0f0f0)",
                  }}
                  variant="gradient"
                  gradient={{ from: "indigo", to: "cyan" }}
                >
                  <Text align="center" size="lg" weight={500}>
                    {item?.title}
                  </Text>

                  <Text align="center" size="md" sx={{ padding: 20 }}>
                    {item.dcr}
                  </Text>
                </Box>
              </Link>
            </Grid.Col>
          ))}
        </Grid>
      </div>
    </Container>
  );
}
